/*
 * Copyright (c) 2018-2023 MemberCenter, a subsidiary of Cameron Collective
 *   All Rights Reserved
 */
import CreditCardIcon from '@mui/icons-material/CreditCardOutlined';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Typography from '@mui/material/Typography';

import { styles } from './styles';

const steps = [
	{
		primary: 'member communications',
		secondary: 'The email address you use will be the same used for your automated emails to members.'
	},
	{
		primary: 'link accounts',
		secondary: 'Link your HubSpot and Square accounts to begin.'
	},
	{
		primary: 'Define Member Types',
		secondary: 'Define your membership types. Select how often your members renew and for what amount.'
	},
	{
		primary: 'Create membership form',
		secondary: 'Create a custom membership form for members to register on your website.'
	},
	{
		primary: 'create member emails',
		secondary: 'Create and test your automated renewal and confirmation emails.'
	},
	{
		primary: 'sign up members',
		secondary: 'Use embeddable code to enable members to register and renew their membership on your website.'
	}
];
const SignUpDescription = () => {
	return (
		<>
			<List sx={styles.root}>
				<ListItem>
					<ListItemAvatar>
						<Avatar sx={styles.avatar}>
							<CreditCardIcon />
						</Avatar>
					</ListItemAvatar>
					<Box sx={{ display: 'flex', flexDirection: 'column' }}>
						<Typography component={'span'} color="primary" variant="h6">
							COMPLEMENTARY ONE MONTH TRIAL
						</Typography>
						<Typography component={'span'} variant="subtitle1">
							No credit card needed
						</Typography>
					</Box>
				</ListItem>
			</List>
			<Divider />
			<List>
				{steps.map(step => (
					<ListItem key={Math.random()}>
						<Box sx={{ display: 'flex', flexDirection: 'column' }}>
							<Typography component={'span'} color="primary" variant="button">
								{step.primary}
							</Typography>
							<Typography component={'span'} variant="subtitle1">
								{step.secondary}
							</Typography>
						</Box>
					</ListItem>
				))}
			</List>
		</>
	);
};

export default SignUpDescription;
